import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Page not found</h2>
        <p className="text-gray-600 dark:text-gray-400 mb-4">
          The page you're looking for doesn't exist.
        </p>
        <Link to="/" className="text-brand-navy dark:text-brand-sky hover:underline">
          Go home
        </Link>
      </div>
    </div>
  );
}
